/**
 * 特集タイトル下のラインアニメーション
 * スクロールでタイトルが画面内に入ったら、ラインを左から右へ伸ばす
 */

const INVIEW_CLASS = "is-inview";
const READY_ATTR = "data-feature-title-line-ready";
const TARGET_SEL = "[data-feature-title-line]";

/**
 * 初期状態（scaleX 0）を描画してから is-inview を付与する
 */
const playLine = (target: Element): void => {
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      target.classList.add(INVIEW_CLASS);
    });
  });
};

/**
 * タイトルが画面内に入ったらラインアニメーションを開始する
 */
const observeTargets = (): void => {
  const targets = document.querySelectorAll(TARGET_SEL);
  if (targets.length === 0) return;

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    targets.forEach((target) => {
      target.classList.add(INVIEW_CLASS);
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        playLine(entry.target);
      }
    },
    {
      threshold: 0,
      rootMargin: "0px 0px -200px 0px",
    },
  );

  targets.forEach((target) => {
    if (target.getAttribute(READY_ATTR) === "true") return;
    target.setAttribute(READY_ATTR, "true");
    observer.observe(target);
  });
};

/**
 * 特集タイトル下のラインアニメーションを初期化
 */
export function featureTitleLine(): void {
  observeTargets();
  document.addEventListener("shopify:section:load", () => {
    observeTargets();
  });
}
